/********************************************************************************
Filename: np-news-overview.js
Created: 29 Sep 2022
Author: Ron Robertson
Description: Displays an overview of news elements
Usage Example:
<np-news-overview></np-news-overview>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
          #newsOverview{

            font-size: var(--bodyFontSize);
            font-family: var(--bodyFontFamily);
          }
          .newsOverviewMain{
            width:var(--content-width);
            margin:0 auto;
          }
          #articlesWrapper{
            display:grid;
            grid-template-columns:1fr;
            width: var(--content-width);
            justify-content: space-between;
            margin:0 auto;
          }
          .sectionTitle{
            // font-size: var(--h2FontSize);
            font-size: 36px;
            font-family: var(--h2FontFamily);
            font-weight:normal;
            margin:0 auto 24px;
          }
          #filtersWrapper{
            margin:0 auto 48px;
            display:flex;
            column-gap: 15px;
            row-gap: 15px;
            flex-wrap: wrap;
          }

          #filtersWrapper,
          .sectionTitle{
            width: var(--content-width);
          }

          #filtersWrapper button{
            border:1px solid #41B6E6;
            font-size: 14px;
            font-family: var(--bodyFontFamily);
            padding:10px 16px 6px;
            background-color:transparent;
            border-radius: 4px;
            color:#41B6E6;
            transition:background-color 0.3s ease-in-out;
            margin:0;
          }

          #filtersWrapper button:hover{
            cursor:pointer;
          }
          #filtersWrapper button.selected{
            background-color:#41B6E6;
            color:#ffffff;
          }
          #newsCarousel{
            display: flex;
            justify-content: center;
            margin-bottom: 80px;
          }


          @media screen and (min-width: 768px) {
            #articlesWrapper{
              grid-template-columns:repeat(2, calc((var(--col-width) * 6) + (var(--gutter-width) * 5)));
              justify-content: space-between;
              width: calc((var(--col-width) * 12) + (var(--gutter-width) * 11));
            }
          }
          @media screen and (min-width: 960px) {
          }
          @media screen and (min-width: 1200px) {
            #articlesWrapper{
              grid-template-columns:repeat(3, 315px);
              width: calc((var(--col-width) * 10) + (var(--gutter-width) * 11));
            }
            #filtersWrapper,
            .sectionTitle{
              width: calc((var(--col-width) * 10) + (var(--gutter-width) * 11));
            }
          }
          @media screen and (min-width: 1920px) {
            #articlesWrapper{
              grid-template-columns: repeat(4, calc((var(--col-width) * 3) + (var(--gutter-width) * 2)));
              width: var(--content-width);
            }
            #filtersWrapper,
            .sectionTitle{
              width: var(--content-width);
            }
          }

        </style>

        <div id="newsOverview">
          <div id="carouselWrapper">
            <np-carousel id='newsCarousel'></np-carousel>
          </div>

          <div class="newsOverviewMain">
            <h2 class="sectionTitle">OptiTrack News</h2>
            <div id="filtersWrapper">
              <button id="filterAllTrigger" class="selected">All Articles</button>
              <button id="filterCamerasTrigger">Cameras</button>
              <button id="filterSoftwareTrigger">Software</button>
              <button id="filterEventsTrigger">Events</button>
              <button id="filterNewsTrigger">News</button>
              <button id="filterVPTrigger">Virtual Production</button>
              <button id="filterVRTrigger">Virtual Reality</button>
              <button id="filterRoboticsTrigger">Robotics</button>
              <button id="filterAnimationTrigger">Animation</button>
              <button id="filterMovementSciencesTrigger">Movement Sciences</button>
            </div><!--END filtersWrapper-->
            <div id="articlesWrapper"></div><!--END articlesWrapper-->
          </div><!--END newsOverviewMain-->
        </div><!--END newsOverview-->
    `;

    class NpNewsOverview extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            this.fetchData = this.fetchData.bind(this);
            this.populateArticles = this.populateArticles.bind(this);
            this.filterArticles = this.filterArticles.bind(this);
            this.filterTriggerEventHandler = this.filterTriggerEventHandler.bind(this);
            this.sortByDate = this.sortByDate.bind(this);
            this.paginate = this.paginate.bind(this);


            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.newsOverview = this.shadowRoot.getElementById("newsOverview");
            this.articlesWrapper = this.shadowRoot.getElementById("articlesWrapper");

            this.filtersWrapper = this.shadowRoot.getElementById("filtersWrapper");
            this.filterAllTrigger = this.shadowRoot.getElementById("filterAllTrigger");
            this.filterCamerasTrigger = this.shadowRoot.getElementById("filterCamerasTrigger");
            this.filterSoftwareTrigger = this.shadowRoot.getElementById("filterSoftwareTrigger");
            this.filterEventsTrigger = this.shadowRoot.getElementById("filterEventsTrigger");
            this.filterNewsTrigger = this.shadowRoot.getElementById("filterNewsTrigger");
            this.filterVPTrigger = this.shadowRoot.getElementById("filterVPTrigger");
            this.filterVRTrigger = this.shadowRoot.getElementById("filterVRTrigger");
            this.filterRoboticsTrigger = this.shadowRoot.getElementById("filterRoboticsTrigger");
            this.filterAnimationTrigger = this.shadowRoot.getElementById("filterAnimationTrigger");
            this.filterMovementSciencesTrigger = this.shadowRoot.getElementById("filterMovementSciencesTrigger");
            this.newsCarouselEle = this.shadowRoot.getElementById("newsCarousel");

            this.apiUrl = window.location.origin + "/newadminapi/"
            if( window.location.origin.indexOf( "localdev") >= 0 ){
                this.apiUrl = "https://dev4.naturalpoint.private/newadminapi/";
            }

            this.monthArray=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];


        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            /*
            if (!this.hasAttribute('myattribute')) {
                this.setAttribute('myattribute', "value");
            }
            */

            /* Set Event Listeners */
            this.filterAllTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterCamerasTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterSoftwareTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterEventsTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterNewsTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterVPTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterVRTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterRoboticsTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterAnimationTrigger.addEventListener('click', this.filterTriggerEventHandler);
            this.filterMovementSciencesTrigger.addEventListener('click', this.filterTriggerEventHandler);

            this.fetchData();

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return [];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {
        /*
        if(name === 'data-url') {
          console.log('data-url changed');
           this.fetchData(newValue);
        }
        */

       }/* END attributesChangedCallback */

      /* Getting attributes */
      /*
      get dataUrl() {
        return this.getAttribute('data-url');
      }
      */

      /* Settinng attributes */
      /*
      set dataUrl(newValue) {
        this.setAttribute('data-url', newValue);
      }
      */


      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        this.filterAllTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterCamerasTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterSoftwareTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterEventsTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterNewsTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterVPTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterVRTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterRoboticsTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterAnimationTrigger.removeEventListener('click', this.filterTriggerEventHandler);
        this.filterMovementSciencesTrigger.removeEventListener('click', this.filterTriggerEventHandler);

        //remove all event listeners for articles
        let allNewsSummary = this.articlesWrapper.querySelectorAll('np-news-summary');
        allNewsSummary.forEach((newsSummary) => {
          newsSummary.removeEventListener('click', this.onRouterLinkClick);
        });
      }

      /* Method */
      //retreives data for displaying articles
      fetchData() {
        let dataUrl = this.apiUrl + 'articles';
        //get data for view
        if(dataUrl){
            fetch(dataUrl)
            .then(response => response.json())
            .then(data => {
                this.responseData = data;

                //order by date
                data.sort(this.sortByDate);

                this.populateArticles(data);
                this.populateCarousel(data);
            })
            .catch((error) => {
              console.log('Unable to load data: ', error)
              this.articlesWrapper.innerHTML = "<div><h3>Unable to load data</h3>" + error + "</div>";
            });
        }
      }

      filterTriggerEventHandler(e) {
        //get the category from the button clicked
        let category = e.target.innerHTML;

        //remove the 'selected' class from all other triggers
        this.filterAllTrigger.classList.remove('selected');
        this.filterCamerasTrigger.classList.remove('selected');
        this.filterSoftwareTrigger.classList.remove('selected');
        this.filterEventsTrigger.classList.remove('selected');
        this.filterNewsTrigger.classList.remove('selected');
        this.filterVPTrigger.classList.remove('selected');
        this.filterVRTrigger.classList.remove('selected');
        this.filterRoboticsTrigger.classList.remove('selected');
        this.filterAnimationTrigger.classList.remove('selected');
        this.filterMovementSciencesTrigger.classList.remove('selected');

        //Add the 'selected' class to the clicked trigger
        if(!e.target.classList.contains('selected')){
          e.target.classList.add('selected');
        }

        this.filterArticles(category);

      }

      filterArticles(category) {

        let newData = this.responseData;

        //Use unfiltered Data
        if(category == 'All Articles'){

        }else{

          //filter the data by category
          newData = this.responseData.filter(function (article) {
            return article.category == category;
          });

        }

        //populate articles with new data
        this.populateArticles(newData);
      }

      populateArticles(data) {

        if(data.length > 0){

          //clear out previous content
          this.articlesWrapper.innerHTML = "";

          data.forEach((article) => {
            let newsSummary = document.createElement("np-news-summary");
            newsSummary.setAttribute('title', article.title);
            newsSummary.setAttribute('category', article.category);
            newsSummary.setAttribute('date', article.date);
            newsSummary.setAttribute('img', article.img);

            newsSummary.setAttribute('router-link', "/news/"+article.id+"/"+article.title.replaceAll(' ', '-'));
            newsSummary.addEventListener('click', this.onRouterLinkClick);

            this.articlesWrapper.appendChild(newsSummary);
          });

        } else {
          this.articlesWrapper.innerHTML = "<h3>Articles Not Found</h3>";
        }

      }

      populateCarousel(data) {
        if(data.length > 0){

          //clear out previous content
          this.newsCarouselEle.innerHTML = "";
          let firstSlide = false;

          data.forEach((article) => {
            if(article.includeInCarousel){
              let newSlide = document.createElement('np-carousel-slide');
              if(!firstSlide){
                newSlide.classList.add('displayed');
                firstSlide = true;
              }else{
                newSlide.classList.add('right');
              }
              newSlide.setAttribute('title',article.title);
              newSlide.setAttribute('img',article.img);
              newSlide.setAttribute('category',article.category);

              if(article.date){
                let dateObj = new Date(article.date + "T00:00:00");
                let month = this.monthArray[parseInt(dateObj.getMonth())]
                let year = dateObj.getFullYear();
                newSlide.setAttribute('date', month + " " + year);
              }
              newSlide.setAttribute('link-url',"/news/"+article.id+"/"+article.title.replaceAll(' ', '-'));

              this.newsCarouselEle.appendChild(newSlide);
            }
          });
        } else {

        }
      }

      //Sorts the array of objects by the date
      sortByDate(a, b) {
        if(a.date > b.date) {
          return -1;
        }
        if(a.date < b.date){
          return 1;
        }
        return 0;
      }

      //returns part of an array by page size and number
      paginate(array, pageSize, pageNumber){
        return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
      }

      //dispatches the event so other components can listen for it
      onRouterLinkClick(event) {
        event.preventDefault();
        // Dispatch the event
        this.dispatchEvent(new CustomEvent('routerLinkClick',{bubbles:true,composed:true,detail:{'url':event.target.getAttribute('router-link')}}));
      }

    } /* END class */

    window.customElements.define('np-news-overview', NpNewsOverview);

  })();
